import { TransformItemDataByDefault } from '@/Core/Features/UI/CrudResource/handlers/table'
import { CheckNodeHelperTask } from '@/Core/Tasks/Utils/CheckNodeHelperTask'

import { StatusCell } from './StatusCell'

/**
 * view для поля типу status у ресурсі: у картці запису (режим перегляду) малює
 * Ship-бейдж із меню замість Core StatusDropdownView.
 * Core викликає view двома способами: ({ field, formContext, value }) з FormField
 * і (value, formContext) з valueViewTransformer — підтримуємо обидва.
 */
export const statusFieldView = (argOrValue: any, maybeFormContext?: any) => {
    let value: unknown
    let formContext: any
    let definition: any

    if (argOrValue && typeof argOrValue === 'object' && 'formContext' in argOrValue) {
        value = argOrValue.value
        formContext = argOrValue.formContext
        definition = argOrValue.field?.definition
    } else {
        value = argOrValue
        formContext = maybeFormContext
    }

    if (typeof value !== 'string' || value === '') return '-'

    const item = formContext?.initialValues ?? {}
    const field = definition ?? formContext?.fieldsSource?.status ?? {}

    return <StatusCell value={value} field={field} item={item} />
}

/**
 * Обробник даних рядка таблиці замість Core TransformItemDataByDefault:
 * спершу підставляє Ship-бейдж у комірки полів типу status, далі віддає рядок
 * ядру, яке React-елементи не чіпає.
 */
export const TransformItemDataWithStatusCell = ({ item, tableContext }: { item: any; tableContext: any }) => {
    const crudContext = tableContext?.storages?.crudContext
    const fields: Record<string, any> = crudContext?.resource?.fields ?? {}

    Object.keys(fields).forEach((key) => {
        const field = fields[key]
        if (field?.type !== 'status') return
        const raw = item?.[key]
        if (typeof raw !== 'string' || raw === '' || CheckNodeHelperTask.isElement(raw)) return
        item[key] = <StatusCell value={raw} field={field} item={item} crudContext={crudContext} />
    })

    TransformItemDataByDefault({ item, tableContext })
}
